import applyAddonConfig from 'uniba-volto-persone/config/config.js';

const applyConfig = (config) => {
  return applyAddonConfig(config);
};

export default applyConfig;
